import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'school-two-column-layout',
  templateUrl: './school-two-column-layout.component.html',
  styleUrls: ['./school-two-column-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SchoolTwoColumnLayoutComponent {}
